<template>
  <v-container fluid>
    <a-form layout="vertical">
      <a-row :gutter="8">
        <a-col :span="24" :xxl="4" :xl="6" :lg="8" :md="12">
          <a-form-item label="订单日期">
            <a-range-picker v-model="queryForm.day_range" :mode="['date', 'date']" :placeholder="['开始日期', '结束日期']"
              :locale="locale" :allowClear="false" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" style="width:100%;" />
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label="车牌号">
            <a-input v-model="queryForm.vehicle_number" placeholder="车牌号" style="width:100%;"
              @keyup.enter="getdata()" />
          </a-form-item>
        </a-col>
        <!-- <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label="状态">
            <a-select v-model="queryForm.match_state" :options="[
              { label: '未匹配', value: 0 },
              { label: '已匹配', value: 1 },
            ]" :allowClear="true" placeholder="请选择" style="width:100%;">
            </a-select>
          </a-form-item>
        </a-col> -->
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label=".">
            <a-space>
              <a-button @click="getdata()" type="primary">
                查询
              </a-button>
              <a-button @click="() => $refs.uploadRef.showupload()" class="btn-cyan">
                <a-icon type="upload" />上传明细
              </a-button>
              <a-button @click="download" class="btn-success">
                <a-icon type="download" />下载明细
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-tabs v-model="queryForm.match_state" size="small" @change="getdata()">
      <a-tab-pane :key="0" tab="未匹配"></a-tab-pane>
      <a-tab-pane :key="1" tab="已匹配"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="summaryList" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="order_number" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="volume" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="amount" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="real_amount" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="pay_amount" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="create_time" slot-scope="text, record">
          {{ record._isSummary ? '' : record.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="organization" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ record._isSummary ? record.organization : unitPrice(record) }}
          </span>
        </template>
        <template slot="match_state" slot-scope="text, record">
          <template v-if="!record._isSummary">
            <v-btn v-if="record.match_state === 1" color="primary" text tile small @click="showmatchresult(record)">
              已匹配
            </v-btn>
            <span v-else>未匹配</span>
          </template>
        </template>
        <!-- <template slot="action" slot-scope="text, record">
          <a-space>
            <a-popconfirm title="删除油卡消费记录" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template> -->
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="matchmodel" persistent max-width="600px">
      <v-card>
        <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
          匹配详情
          <v-icon @click="() => matchmodel = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <a-table size="small" :columns="matchheaders" :data-source="matchresult" :pagination="false"
            :locale="{ emptyText: '暂无数据' }">
          </a-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <UploadTask ref="uploadRef" modelTitle="上传油卡消费明细"
      :alertText="`上传Excel文件需包含 <span class='error--text'>车牌号</span>、<span class='error--text'>卡号</span>、<span>实付金额</span>、<span class='error--text'>油站名称</span>、<span class='error--text'>订单号</span>、<span>订单时间</span>、<span class='error--text'>油量</span>、<span>油品应收金额</span>、<span>油品实收金额</span> 字段。`"
      uploadType="fuelcardbill" :templateFile="templateFile" />
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
import UploadTask from "@/components/uploadtask.vue";
export default {
  name: "FuelCardList",
  data() {
    return {
      locale,
      queryForm: {
        day_range: [],
        vehicle_number: "",
        match_state: 0,
      },
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        { title: "订单号", dataIndex: "order_number", scopedSlots: { customRender: "order_number" }, width: 150, align: "center" },
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 120, align: "center" },
        { title: "状态", dataIndex: "match_state", scopedSlots: { customRender: "match_state" }, width: 120, align: "center" },
        { title: "卡号", dataIndex: "card_no", scopedSlots: { customRender: "card_no" }, width: 120, align: "center" },
        { title: "司机编号", dataIndex: "driver_no", scopedSlots: { customRender: "driver_no" }, width: 120, align: "center" },//套牌号
        { title: "商品品类", dataIndex: "product_cat", scopedSlots: { customRender: "product_cat" }, width: 120, align: "center" },
        { title: "实付金额(元)", dataIndex: "pay_amount", scopedSlots: { customRender: "pay_amount" }, width: 120, align: "center" },
        { title: "油站名称", dataIndex: "fuel_station", scopedSlots: { customRender: "fuel_station" }, width: 120, align: "center" },//元/月,包车费/月租,自动关联过来,临时车在调度计划里填写然后关联到路单和财务账单
        { title: "订单时间", dataIndex: "order_time", scopedSlots: { customRender: "order_time" }, width: 120, align: "center" },
        { title: "交易流水号", dataIndex: "trade_no", scopedSlots: { customRender: "trade_no" }, width: 180, align: "center" },
        { title: "所属机构", dataIndex: "org", scopedSlots: { customRender: "org" }, width: 120, align: "center" },
        { title: "油品品号", dataIndex: "fuel_type", scopedSlots: { customRender: "fuel_type" }, width: 120, align: "center" },
        { title: "油量(升)", dataIndex: "volume", scopedSlots: { customRender: "volume" }, width: 120, align: "center" },
        { title: "油品应收金额(元)", dataIndex: "amount", scopedSlots: { customRender: "amount" }, width: 120, align: "center" },
        { title: "油品实收金额(元)", dataIndex: "real_amount", scopedSlots: { customRender: "real_amount" }, width: 120, align: "center" },
        { title: "单价(升/元)", dataIndex: "organization", scopedSlots: { customRender: "organization" }, width: 120, align: "center" },
        { title: "油品折扣(元)", dataIndex: "discount", scopedSlots: { customRender: "discount" }, width: 120, align: "center" },
        { title: "余额(元)", dataIndex: "balance", scopedSlots: { customRender: "balance" }, width: 120, align: "center" },
        { title: "账号编号", dataIndex: "account_no", scopedSlots: { customRender: "account_no" }, width: 120, align: "center" },
        { title: "上传时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 180, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      templateFile: {
        url: `${process.env.BASE_URL}template/油卡消费明细导入模板.xlsx`,
        name: '油卡消费明细导入模板.xlsx',
      },
      matchmodel: false,
      matchheaders: [
        { title: "邮路", dataIndex: "postroute", scopedSlots: { customRender: "postroute" } },
        { title: "派车单号", dataIndex: "dispatch_no", scopedSlots: { customRender: "dispatch_no" } },
        { title: "里程", dataIndex: "mileage", scopedSlots: { customRender: "mileage" } },
        { title: "费用", dataIndex: "fuelcard_fee", scopedSlots: { customRender: "fuelcard_fee" } },
        { title: "油量(升)", dataIndex: "fuel_volume", scopedSlots: { customRender: "fuel_volume" } },
      ],
      matchresult: [],
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    summaryList() {
      if (!this.list || this.list.length === 0) return [];
      const total = this.list.reduce((acc, row) => ({
        volume: acc.volume + (Number(row.volume) || 0),
        amount: acc.amount + (Number(row.amount) || 0),
        real_amount: acc.real_amount + (Number(row.real_amount) || 0),
        pay_amount: acc.pay_amount + (Number(row.pay_amount) || 0),
      }), { volume: 0, amount: 0, real_amount: 0, pay_amount: 0 });
      return [
        {
          _id: 'summary',
          _isSummary: true,
          order_number: '合计',
          volume: total.volume.toFixed(2),
          amount: total.amount.toFixed(2),
          real_amount: total.real_amount.toFixed(2),
          pay_amount: total.pay_amount.toFixed(2),
          organization: total.volume ? (total.pay_amount / total.volume).toFixed(2) : "0.00",
        },
        ...this.list,
      ];
    },
  },
  components: { UploadTask },
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 360;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 360;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    let start_day = this.$moment().startOf('month').format('YYYY-MM-DD');
    let end_day = this.$moment().endOf('month').format('YYYY-MM-DD');
    this.queryForm = {
      day_range: [start_day, end_day],
      vehicle_number: "",
      match_state: 0,
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    download() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/fuelcardbill/list", { page: this.page, limit: this.limit, ...this.queryForm, action: "download" }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    unitPrice(record) {
      if (record._isSummary) return "";
      const amount = Number(record.real_amount) || 0;
      const volume = Number(record.volume) || 0;
      if (!volume) return "-";
      return (amount / volume).toFixed(2);
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/fuelcardbill/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/fuelcardbill/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showmatchresult(item) {
      this.matchresult = [
        ...(item.bills.length > 0 ? [
          {
            postroute: "合计",
            mileage: item.bills.reduce((a, b) => a.plus(b.mileage), this.$d()).toString(),
            fuelcard_fee: item.bills.reduce((a, b) => a.plus(b.fuelcard_fee), this.$d()).toString(),
            fuel_volume: item.bills.reduce((a, b) => a.plus(b.fuel_volume), this.$d()).toString(),
          }
        ] : []),
        ...item.bills,
      ];
      this.matchmodel = true;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
